import gsap from "gsap";
import Draggable from "gsap/Draggable";
import ScrollMagic from "scrollmagic";
import {
	ScrollTrigger
} from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";



jQuery(document).ready(function ($) {
	gsap.registerPlugin(Draggable);
	gsap.registerPlugin(ScrollTrigger);
	gsap.registerPlugin(CustomEase);
	CustomEase.create("classic", ".33,0,0,1");
	consoleMessage: {
		console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
	}

	modernizer: {
		if (!Modernizr.objectfit) {
			$('.object-fit').each(function () {
				var $container = $(this),
					imgUrl = $container.find('img').prop('src');
				if (imgUrl) {
					$container
						.css('backgroundImage', 'url(' + imgUrl + ')')
						.addClass('not-compatible');
				}
			});
		}
	}

	fixedheader: {
		$(function () {


			// if ($(window).width() > 1200) {
			var scrollPos = 0;
			
			$(window).scroll(function () {
				console.log('scroll');
				let buttonCircle = $('.top-nav').find($('#button-circle'));
				let buttonRectangle = $('.top-nav').find($('#button-rectangle'));
			
				if ((document.body.getBoundingClientRect()).top > scrollPos) {
					// console.log("scrolling up");

					if ($(window).scrollTop() < 180) {
						// $('.top-nav').addClass("transform-none");
						// $('.top-nav').addClass('fixed-header-transform');
						$('.fixed-header').css('transform', "translateY(-100%)") ;
					}
					// if($(window).scrollTop() < 170) {
					// 	// if($('.top-nav').hasClass('fixed-header')) {
					// 		// $('.top-nav').removeClass("fixed-header-transform");										
					// 	// }
					// }
					// if($(window).scrollTop() < 160 ) {
					// 	// $('.top-nav').removeClass('fixed-header');
					// 	buttonCircle.addClass('d-xl-block');
					// 	buttonRectangle.addClass('d-none');
					// }
					// if($(window).scrollTop < 150) {
					// 	if($('.top-nav').hasClass('fixed-header-transform')) {
					// 		// $('.top-nav').removeClass('transform-none');					
					// 	}
					// }

				}
				else {
					// console.log("scrolling down ");
					// if ($(window).scrollTop() >= 150) {
					// 	// $('.top-nav').removeClass("transform-none");
					// 	// $('.top-nav').removeClass('fixed-header-transform');
					// 	// if(!$('.top-nav').hasClass('fixed-header')) {
					// 		// $('.top-nav').addClass('fixed-header-transform');						
					// 	}						
					// }
					// if ($(window).scrollTop() >= 165) {						
					// 	buttonCircle.removeClass('d-xl-block');
					// 	buttonRectangle.removeClass('d-none');
					// 	// $('.top-nav').addClass('fixed-header');
					// }
					if ($(window).scrollTop() >= 180) {		
					// if($('.top-nav').hasClass('fixed-header-transform')) {				
					// 	// $('.top-nav').addClass("transform-none");					
					// }
						// setTimeout(function() { 
						// 	$('.top-nav').removeClass("transform-none");
						// 	$('.top-nav').removeClass('fixed-header-transform');
						//  } , 2000);
						$('.fixed-header').css('transform', "translateY(0%)");
					}
				}
									
				// else {
				// 	$('.top-nav').removeClass('fixed-header');
				// 	$('.top-nav').removeClass('fixed-header-transform');
				// 	$('.top-nav').removeClass("transform-none");					
				// 	buttonCircle.addClass('d-xl-block');
				// 	buttonRectangle.addClass('d-none');
				// }

				scrollPos = (document.body.getBoundingClientRect()).top;
				
			});
		// }
		});
	}

	search: {
		$('.search-icon').on('click', function (e) {
			$('.searchform').toggleClass('search-open');
			$(this).toggleClass('submit-zindex');
			$('.select-lang').removeClass('transform-height');
			$('#menu-main-menu-top, .lang_dropdown').fadeOut();
			$("#s").focus();
			setTimeout(function () {
				$('.close-search').fadeIn();
			}, 300);
		});
		$('.close-search').on('click', function (e) {
			$(this).fadeOut();
			$('.searchform').removeClass('search-open');
			$('.search-icon').removeClass('submit-zindex');
			$('#menu-main-menu-top, .lang_dropdown').fadeIn();
		});
	}

	menu: {
		// // Open submenu on click
		// $('.top-nav .menu-item-has-children > a').on('click', function (e) {
		// 	e.preventDefault();

		// 	$('.menu-item-has-children').removeClass('sub-menu-open'); // reset
		// 	$('.sub-menu-wrap').removeClass('sub-menu-open'); // reset

		// 	$(this).closest('.menu-item-has-children').toggleClass('sub-menu-open');
		// 	$(this).next('.sub-menu-wrap').toggleClass('sub-menu-open');
		// });
		// // Open menu with tabs - accessibility
		// $('.top-nav .sub-menu-wrap a').on('focusin', function () {
		// 	$(this).closest('.menu-item-has-children').addClass('sub-menu-open');
		// 	$(this).closest('.sub-menu-wrap').addClass('sub-menu-open');

		// 	console.log($(this));
		// });
		// $('.top-nav .sub-menu-wrap a').on('focusout', function () {
		// 	$(this).closest('.menu-item-has-children').removeClass('sub-menu-open');
		// 	$(this).closest('.sub-menu-wrap').removeClass('sub-menu-open');
		// });
		// // Close on click outside.
		// $(document).on('click', function (e) {
		// 	if (!$(e.target).parent().hasClass('menu-item') && $('.sub-menu-wrap').has(e.target).length === 0) {
		// 		$('.menu-item-has-children').removeClass('sub-menu-open');
		// 		$('.sub-menu-wrap').removeClass('sub-menu-open');
		// 	}
		// });
	}

	anchorlinks: {
		$(document).on('click', '.scroll-to', function (event) {
			event.preventDefault();

			$('html, body').animate({
				scrollTop: $($.attr(this, 'href')).offset().top
			}, 500);
		});
	}

	externallinks: {
		$('a[href^="mailto:"]').each(function () {
			$(this).addClass('email-link');
		});

		// $('a:not(.email-link):not([class^="magnific-"])').each(function () {
		// 	var a = new RegExp('/' + window.location.host + '/');

		// 	if (!a.test(this.href)) {
		// 		$(this).click(function (event) {
		// 			event.preventDefault();
		// 			window.open(this.href, '_blank');
		// 		});
		// 	}
		// });
		pdfs: {
			// Open PDFs in new window
			$(function () {
				$('a[href$=".pdf"]').prop('target', '_blank');
			});
		}
	}

	slider: {
		$('.full-width-slider').slick({
			dots: true,
			arrows: true,
			fade: true,
			autoplay: true,
			autoplaySpeed: 4500,
			prevArrow: $('.arrow-prev'),
			nextArrow: $('.arrow-next')
		});
		$('.js-testimonial-slider').each(function() {
			
			$(this).slick({
				dots: true,
				arrows: true,
				nextArrow: $(this).parent().find('.next-arrow-testimonial-slider'),
				fade: false,
				autoplay: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplaySpeed: 10000,
			});
		})


		$('.js-news-slider').slick({
			dots: true,
			arrows: false,
			fade: false,
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplaySpeed: 4500,
		});

		$('.video-slider').slick({
			dots: true,
			arrows: true,
			fade: false,
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplaySpeed: 4500,
			appendDots: $('.slider-dots'),
			nextArrow: $('.next-arrow-slider'),
			prevArrow: $('.prev-arrow-slider')
		});


		/**
		 * Gallery slider with thumbnails navigation.
		 */
		var status = $('.gallery-slider__full-nav .pages');
		var slickElement = $('.gallery-slider__full');

		slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
			//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
			var i = (currentSlide ? currentSlide : 0) + 1;
			status.text(i + ' of ' + slick.slideCount);
		});

		$('.gallery-slider__full').slick({
			dots: false,
			arrows: true,
			fade: true,
			asNavFor: '.gallery-slider__thumb',
			appendArrows: '.gallery-slider__full-nav',
		});
		$('.gallery-slider__thumb').slick({
			dots: false,
			arrows: true,
			slidesToShow: 4,
			// centerMode: true,
			focusOnSelect: true,
			asNavFor: '.gallery-slider__full',
		});
	}


	responsiveVideos: {
		$('iframe[src*="youtube"]').each(function() {			
			$(this).wrap("<div class='responsive-iframe'></div>");
		});
		$('iframe[src*="vimeo"]').each(function() {			
			$(this).wrap("<div class='responsive-iframe'></div>");
		});
	}
	magnific: {
		// IFRAME
		$('.magnific-video').magnificPopup({
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false,

			iframe: {
				markup: '<div class="mfp-iframe-scaler">' +
					'<div class="mfp-close"></div>' +
					'<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
					'</div>',
				patterns: {
					youtu: {
						index: 'youtu.be',
						id: function (url) {

							// Capture everything after the hostname, excluding possible querystrings.
							var m = url.match(/^.+youtu.be\/([^?]+)/);

							if (null !== m) {
								return m[1];
							}

							return null;

						},
						// Use the captured video ID in an embed URL. 
						// Add/remove querystrings as desired.
						src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
					},
					youtube: {
						index: 'youtube.com/',
						id: 'v=',
						src: 'https://www.youtube.com/embed/%id%?autoplay=1'
					}
				}
			}
		});


		// INLINE
		$('.magnific-inline-popup').magnificPopup({
			type: 'inline',

			fixedContentPos: false,
			fixedBgPos: true,

			overflowY: 'auto',

			closeBtnInside: true,
			preloader: false,

			midClick: true,
			removalDelay: 300,
			mainClass: 'my-mfp-zoom-in'
		});

		$('.magnific-inline-popup--slide-in').magnificPopup({
			type: 'inline',

			fixedContentPos: true,
			fixedBgPos: true,



			closeBtnInside: true,
			closeOnBgClick: true,
			preloader: false,

			midClick: true,
			removalDelay: 300,
			mainClass: 'my-mfp-slide-in'
		});


		// GALLERY SINGLE IMAGE
		$('.magnific-gallery-single-image').magnificPopup({
			type: 'image',
			closeOnContentClick: true,
			mainClass: 'mfp-img-single',
			image: {
				verticalFit: true,
				titleSrc: function titleSrc(item) {
					return item.el.attr('title');
				}
			},
			gallery: {
				enabled: false
			}
		});

		// GALLERY IMAGE
		$('.magnific-gallery-image').magnificPopup({
			type: 'image',
			closeOnContentClick: true,
			mainClass: 'mfp-img-mobile',
			image: {
				verticalFit: true,
				titleSrc: function (item) {
					return item.el.attr('title');
				}
			},
			gallery: {
				enabled: true
			}
		});
	}

	accordion: {
		if ($('.block--accordion').length) {

			$('.accordion__content--wrapper').css('display', 'none'); // All items closed.

			$('.block--accordion').find('.js-accordion-trigger').on('click', function () {

				// Close only the items in this accordion.
				// $(this).parent().siblings().find('.js-accordion-trigger').next().slideUp('fast'); // reset
				// $(this).parent().siblings().find('.js-accordion-trigger').removeClass('open'); // reset

				// Close items in all accordions on the page.
				//$('.js-accordion-trigger').not(this).next().slideUp('fast'); // reset
				//$('.js-accordion-trigger').not(this).removeClass('open');    // reset

				if ($(this).hasClass('open')) {
					$(this).next().slideUp('fast');
					$(this).removeClass('open');
				} else {
					$(this).next().slideDown('fast');
					$(this).addClass('open');
				}

			});
		}
	}

	/* tabs: {
		const tabs = document.querySelectorAll('[role="tab"]');
		const tabList = document.querySelector('[role="tablist"]');

		if ( tabs ) {

			// Add a click event handler to each tab
			tabs.forEach(tab => {
				tab.addEventListener("click", changeTabs);
			});

			// Enable arrow navigation between tabs in the tab list
			let tabFocus = 0;

			if ( tabList ) {
				tabList.addEventListener("keydown", e => {
					// Move right
					if (e.keyCode === 39 || e.keyCode === 37) {
					tabs[tabFocus].setAttribute("tabindex", -1);
					if (e.keyCode === 39) {
						tabFocus++;
						// If we're at the end, go to the start
						if (tabFocus >= tabs.length) {
						tabFocus = 0;
						}
						// Move left
					} else if (e.keyCode === 37) {
						tabFocus--;
						// If we're at the start, move to the end
						if (tabFocus < 0) {
						tabFocus = tabs.length - 1;
						}
					}
	
					tabs[tabFocus].setAttribute("tabindex", 0);
					tabs[tabFocus].focus();
					}
				});
			}

			function changeTabs(e) {
				console.info('tabs clicked');
				const target = e.target;
				const parent = target.parentNode;
				const grandparent = parent.closest('.tabs');


					console.info(grandparent);
				// Remove all current selected tabs
				parent
					.querySelectorAll('[aria-selected="true"]')
					.forEach(t => t.setAttribute("aria-selected", false));

				// Set this tab as selected
				target.setAttribute("aria-selected", true);

				// Hide all tab panels
				grandparent
					.querySelectorAll('[role="tabpanel"]')
					.forEach(p => p.setAttribute("hidden", true));

				// Show the selected panel
				grandparent.parentNode
					.querySelector(`#${target.getAttribute("aria-controls")}`)
					.removeAttribute("hidden");
			}

		}
	} */

	tabs: {
		$('.tabs__header__tab').on('click', function () {
			let target = $(this).attr('target');
			$('.tabs__header__tab').removeClass('active');
			$(this).addClass('active');
			$('.tabs__content__item').hide();
			$('#' + target).show();
		});
	}

	loadingAnimations: {
		$.fn.isOnScreen = function () {
			var win = $(window);
			var viewport = {
				top: win.scrollTop()
			};
			viewport.bottom = viewport.top + win.height() - 80;

			var bounds = this.offset();
			bounds.bottom = bounds.top + this.outerHeight();

			return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
		};

		// First load Animation
		$('.off-screen').each(function (index) {
			if ($(this).isOnScreen()) {
				$(this).removeClass('off-screen--hide');
			}
		});

		// Animation on scroll
		$(window).scroll(function () {
			$('.off-screen').each(function (index) {
				if ($(this).isOnScreen()) {
					$(this).removeClass('off-screen--hide');
				}
			});
		});
	}
	spherebuttons: {

		// const element = document.querySelector(".cursor");
		// const target = document.querySelector(".button--sphere");
		// const text = document.querySelector(".button__inner");
		// class Cursor {
		// 	constructor(el, target, text) {
		// 		this.el = el;
		// 		// this.target = target;
		// 		// this.text = text;
		// 		// this.triggerDistance = this.target.getBoundingClientRect().width;
		// 		this.bind();
		// 	}

		// 	bind() {
		// 		document.addEventListener("mousemove", this.move.bind(this), false);
		// 	}

		// 	move(e) {
		// 		const cursorPosition = {
		// 			left: e.clientX - 20.5,
		// 			top: e.clientY - 33.5
		// 		};
		// 		document.querySelectorAll(".button--sphere").forEach((single) => {
		// 			const triggerDistance = single.getBoundingClientRect().width / 2 + 20;

		// 			const targetPosition = {
		// 				left: single.getBoundingClientRect().left +
		// 					single.getBoundingClientRect().width / 4,
		// 				top: single.getBoundingClientRect().top +
		// 					single.getBoundingClientRect().height / 4
		// 			};
		// 			const distance = {
		// 				x: targetPosition.left - cursorPosition.left,
		// 				y: targetPosition.top - cursorPosition.top
		// 			};

		// 			const angle = Math.atan2(distance.x, distance.y);
		// 			const hypotenuse = Math.sqrt(
		// 				distance.x * distance.x + distance.y * distance.y
		// 			);
		// 			if (hypotenuse < triggerDistance) {
		// 				// Nikhil - look at this code to adjust the round cursor area sizing

		// 				gsap.to(single.querySelector(".button__inner"), 0.2, {
		// 					x: -((Math.sin(angle) * hypotenuse) / 2),
		// 					y: -((Math.cos(angle) * hypotenuse) / 2)
		// 				});
		// 			} else {
		// 				gsap.to(single.querySelector(".button__inner"), 0.2, {
		// 					x: 0,
		// 					y: 0
		// 				});
		// 			}
		// 		});
		// 	}
		// }
		// const cursor = new Cursor(element, target);

		document.querySelectorAll('.button-container').forEach((single) => {

			const buttonMagnetic = $(single).find($('.button-magnetic'));
			const buttonDeco1 = $(single).find($('.button__deco--1'));
			const buttonDeco2 = $(single).find($('.button__deco--2'));
			const buttonText = $(single).find($('.button__text'));
			
			// $(single).height(buttonDeco1.height());
			// buttonMagnetic.height(buttonDeco1.height());

			buttonMagnetic.mouseleave(function(e){
				console.log('mouseleave');
				gsap.to(this, {duration: 0.4});
				gsap.to(buttonDeco1, { duration: 0.3, scale:1, x: 0, y: 0});
				gsap.to(buttonText, { duration: 0.3, scale:1, x: 0, y: 0, delay: 0.03});
				gsap.to(buttonDeco2,{ duration: 0.3, scale:1, x: 0, y: 0, delay: 0.08}); 

			  });

			  buttonMagnetic.mouseenter(function(e){
				// TweenMax.to(this, 0.3, {height: 150, width: 150});
				// TweenMax.to('.circle', 0.3,{scale:1});
				  // setTimeout(function() {
				  //   TweenMax.to('.outer-circle', 0.2,{scale:1});
				  // }, 2000);
				  buttonMagnetic.mousemove(function(e){   
				callParallax(e);
			  });

			  });



			  function callParallax(e){
				parallaxIt(e, buttonDeco1, 35, 0);
				parallaxIt(e, buttonDeco2, 35, 0.08);
				parallaxIt(e, buttonText, 20, 0.03 );
			  }

			  function parallaxIt(e, target, movement, delay){
				var $this = buttonMagnetic;
				var relX = e.pageX - $this.offset().left;
				var relY = e.pageY - $this.offset().top;

				gsap.to(target, {
					duration: 0.4,
					x: (relX - $this.width()/2) / $this.width() * movement,
					y: (relY - $this.height()/2) / $this.height() * movement,
					ease: "power2",
				  	delay: delay,
					// overwrite: true
				});
			  }
			});
	}

	menu: {
		$('.parent-page > a').on('click', function (e) {
			e.preventDefault();
			let menutoopen = $(this).attr('id');			
			console.log('menutoopen');


			if ($(this).parent().hasClass("active")) {
				$('.parent-page ').removeClass('active');

				$('.sub-menu-wrap').removeClass('sub-menu-open');			
				$('.top-nav').removeClass('menu-active');
				if($('.top-nav').hasClass('fixed-header') && window.innerWidth > 1275) {
					$('.fixed-header').css('background-color', 'black');					
				}
				$('html').removeClass('frozen');
			} else {
				$('.parent-page ').removeClass('active');
				$(this).parent().addClass('active');
				$('.sub-menu-wrap').removeClass('sub-menu-open');
				$('#sub_' + menutoopen).toggleClass('sub-menu-open');	
				if($('.top-nav').hasClass('fixed-header') && window.innerWidth > 1275) {
					$('.fixed-header').css('background-color', 'transparent');							
				}
				$('.top-nav').addClass('menu-active');
				$('html').addClass('frozen');

			}


		});
		$('.sub-menu__close, .hide-sub-menu, #content-wrap, .back-button').on('click', function () {

			$('.parent-page ').removeClass('active');

			$('.sub-menu-wrap').removeClass('sub-menu-open');
			if($('.top-nav').hasClass('fixed-header') && window.innerWidth > 1275) {
				$('.fixed-header').css('background-color', 'black');
			}
			$('.top-nav').removeClass('menu-active');

			$('html').removeClass('frozen');
		});
		let menuopen;
		$('.hamburger').on('click', function () {
		

			
				menuopen = true
				$('.top-nav').toggleClass('mobileMenu');
				if($('.fixed-header').hasClass('mobileMenu') ) {
					$('.fixed-header').css('background-color', 'transparent');
					$('.fixed-header .top-nav__logo').css('opacity', 0);
					$('.fixed-header .top-nav__logo').css('pointer-events', 'none');
				} else {
					$('.fixed-header').css('background-color', 'black');	
					$('.fixed-header .top-nav__logo').css('opacity', 1);
					$('.fixed-header .top-nav__logo').css('pointer-events', 'all');
				}
				$(this).toggleClass('open');
				$('html').toggleClass('frozen');
		
				setTimeout(function () {
					$('#main-menu').toggleClass('open');
				}, 300);

			

		});
		$('.banner__menu .section-trigger').on('click', function (e) {
			e.preventDefault();
			$('.banner__menu').toggleClass('open');

		});
	}

	blogScrollButton: {
		if($('body').hasClass('blog')) {
			var postsTop = $('.block--posts-grid').offset().top - 800;
			window.addEventListener('scroll', function () {			
				if($(window).scrollTop() > postsTop) {
					$('.js-scroll-button').removeClass('visible-button');				
				} else {
					$('.js-scroll-button').addClass('visible-button');		
				}	
			});
									
			$('.js-scroll-button').on('click', function (event) {
				event.preventDefault();
				$('html, body').animate({
					scrollTop: $($.attr(event.target, 'href')).offset().top
				}, 500);
			})
		}	
	}

	courseshover: {
		const allCourses = gsap.utils.toArray(".course-finder__item");
		const courseImageWrap = document.querySelector(".course-finder__image-container");
		const courseImage = document.querySelector(".course-finder__image");

		function initCourses() {
			allCourses.forEach((link) => {
				link.addEventListener("mouseenter", courseHover);
				link.addEventListener("mouseleave", courseHover);
				link.addEventListener("mousemove", moveCourseImage);
			});
		}

		function moveCourseImage(e) {
			let xpos = e.clientX;
			let ypos = e.clientY;
			const tl = gsap.timeline();
			tl.to(courseImageWrap, {
				x: xpos - 118,
				y: ypos - 118
			});
		}

		function courseHover(e) {
			if (e.type === "mouseenter") {
				const targetImage = e.target.dataset.img;

				const t1 = gsap.timeline();
				t1.set(courseImage, {
					backgroundImage: `url(${targetImage})`
				}).to(courseImageWrap, {
					duration: 0.5,
					autoAlpha: 1
				});
			} else if (e.type === "mouseleave") {
				const tl = gsap.timeline();
				tl.to(courseImageWrap, {
					duration: 0.5,
					autoAlpha: 0
				});
			}
		}

		if (allCourses) {
			initCourses();
		}
	}
	largeteaserhover: {

		// const allTeasers = gsap.utils.toArray(".teaser-item__large");
		// const postWrapperScroll = document.querySelector(".post-wrapper--scroll");

		// function initTeaserEvent() {

		// 	postWrapperScroll.addEventListener("mouseleave", postWrapperReset);
		// 	//postWrapperScroll.addEventListener("mousenter", moveEventContainer);
		// 	postWrapperScroll.addEventListener("mousemove", moveEventContainer);
		// }

		// function moveEventContainer(e) {
		// 	let xpos = e.clientX;
		// 	let ypos = e.clientY;
		// 	const tl = gsap.timeline();
		// 	let containerWidth = postWrapperScroll.clientWidth;
		// 	console.log(xpos);
		// 	//if(xpos <  (containerWidth / 3)) {
		// 		tl.to(postWrapperScroll, {
		// 			x: -xpos + (containerWidth / 3)
		// 		});
		// 	//}

		// }
		// function postWrapperReset(e) {
		// 	const tl = gsap.timeline();
		// 	tl.to(postWrapperScroll, {
		// 		x: 0
		// 	});
		// }

		// if(postWrapperScroll) {
		// 	initTeaserEvent();
		// }

		function parallaxIt(e, target, movement, container) {

			gsap.to(container.find(target), 1, {
				x: (pageX_from_center2), // distanceX
				y: (0)
			});
		}

		function parallaxIt2(e, target, movement, container) {

			gsap.to(container.find(target), 1, {
				x: (background_Pos),
				y: (0)
			});
		}

		function parallaxIt3(e, target, movement, container) {

			gsap.to(container.find(target), 1, {
				x: (0),
				y: (distanceY)
			});
		}

		function parallaxIt4(e, target, movement, container) {

			gsap.to(container.find(target), 1, {
				x: (heading_Pos),
				y: (0)
			});
		}

		function calculateDistance(elem, mouseX, mouseY) {
			return Math.floor(Math.sqrt(Math.pow(mouseX - (elem.offset().left + (elem.width() / 2)), 2) + Math.pow(mouseY - (elem.offset().top + (elem.height() / 2)), 2)));
		}

		function calculateDistanceY(elem, mouseY) {
			return Math.floor(Math.pow(mouseY - (elem.offset().top + (elem.height() / 2)), 2)); // bad
		}

		function calculateDistanceX(elem, mouseX) {
			return Math.floor(Math.sqrt(Math.pow(mouseX - (elem.offset().left + (elem.width() / 2)), 2)));
		}

		let $element;
		let percentage_browser_width_half;
		let distanceY;
		let pageX_from_center, pageX_from_center2;
		

		$(".post-wrapper-scroll-container").mousemove(function (e) {

			var browser_width = $(window).width();

			var browser_width_half = browser_width / 2;

			var element_width = $('.post-wrapper-scroll-container').width();

			var element_width_half = element_width / 2;

			var scroll_width_perc = element_width / 100 * 12;

			pageX_from_center = e.pageX - element_width_half + 50;

			$element = $('.post-wrapper-scroll-container');

			let mX = e.pageX;
			let mY = e.pageY;

			distanceY = calculateDistance($element, mX, mY);

			//distanceCalcX = calculateDistance($element, mX, mY);

			let distanceCalcX = calculateDistanceX($element, mX);

			distanceY = distanceY / 25;

			let distanceX = distanceCalcX - scroll_width_perc;


			function percentage(num, per) {

				return (num / 100) * per;
			}

			if ($(window).width() < 1300) {

				percentage_browser_width_half = percentage(browser_width_half, 20);

			} else if ($(window).width() < 1500) {

				percentage_browser_width_half = percentage(browser_width_half, 18);

			} else if ($(window).width() < 1700) {

				percentage_browser_width_half = percentage(browser_width_half, 2);

			} else if ($(window).width() < 2000) {

				percentage_browser_width_half = percentage(browser_width_half, 0);

			} else {

				percentage_browser_width_half = percentage(browser_width_half, 0);

			}

			if (pageX_from_center >= 0) {

				// if a positive number switch to negative

				let heading_pageX_from_center = pageX_from_center;

				heading_pageX_from_center = -pageX_from_center;

				let bg_pageX_from_center = pageX_from_center;

				bg_pageX_from_center = -pageX_from_center;

				let px_value = 500 + percentage_browser_width_half;

				if (pageX_from_center > px_value) {

					//pageX_from_center = 500;

					pageX_from_center2 = -px_value;

				} else {

					pageX_from_center = -pageX_from_center;

					pageX_from_center2 = pageX_from_center;

				}

				distanceX = -distanceX;

				distanceX = distanceX - 90;



				//pageX_from_center3 = pageX_from_center - 100;

				let background_Pos = bg_pageX_from_center / 1.5;

				let heading_Pos = heading_pageX_from_center / 2.1;

			} else {

				// if a negative number switch to positive
				pageX_from_center = Math.abs(pageX_from_center); //

				distanceX = Math.abs(distanceX);

				distanceX = distanceX + 30;

				let px_value = 410 + percentage_browser_width_half;

				if (pageX_from_center > px_value) {

					//pageX_from_center = 500;

					let pageX_from_center2 = px_value;

				} else {

					let pageX_from_center2 = pageX_from_center;

				}

				//pageX_from_center3 = pageX_from_center - 0;

				let background_Pos = pageX_from_center / 1.5;

				let heading_Pos = pageX_from_center / 2.5;

			}


			var browser_height = $(window).height();

			var browser_height_half = browser_height / 2;

			let pageY_from_center = e.pageY - browser_height_half;



			if (pageY_from_center >= 0) {

				// if a negative number switch to positive
				distanceY = Math.abs(distanceY);

			} else {

				// if a positive number switch to negative
				distanceY = -distanceY;

			}

			//console.log(pageX_from_center);	// IMPORTANT

			if ($(window).width() > 769) {

				//parallaxIt3(e, ".post-wrapper--scroll", distanceY, $(this));

				//parallaxIt2(e, ".home-banner-bg", background_Pos, $(this));

				parallaxIt(e, ".post-wrapper--scroll", pageX_from_center2, $(this));

				// //parallaxIt(e, ".h-items-wrap", distanceX, $(this));

				// parallaxIt4(e, ".main-heading-wrap", heading_Pos, $(this));

			}
		});


	}

	homepageScroll: {
		// make homepage reload always at top of page for animation purpose
		if( $('body.home').length ){
			
			$(window).on('beforeunload', function() {
				$(window).scrollTop(0);
			});
		}
	}

	titleanimation: {
		

		if ($('.banner--animate-home').length) {
			var tl = gsap.timeline({
				paused: true
			});

			gsap.set("#rose-bg-overlay, #bruford-bg-overlay, #college-bg-overlay", {
				transformOrigin: "0% 0%"
			});

			tl.set(document.body, {overflow: "hidden"})

			tl
				.to(".banner--home", 0.2, {
					autoAlpha: 1,
					ease: "none" 
				})
				.to("#rose-bg-overlay", 0.8, {
					xPercent: 100,
					ease: "classic"
				}, 0.5)
				.to("#bruford-bg-overlay", 0.8, {
					xPercent: 100,
					ease: "classic"
				}, "<")
				.to("#college-bg-overlay", 0.8, {
					xPercent: 100,
					ease: "classic"
				}, "<")
				.to("#rose-bg-overlay-2", 0.8, {
					xPercent: 100,
					ease: "classic"
				}, ">")
				.to("#bruford-bg-overlay-2", 0.8, {
					xPercent: 100,
					ease: "classic"
				}, "<")
				.to("#college-bg-overlay-2", 0.8, {
					xPercent: 100,
					ease: "classic"
				}, "<")
			
				// .fromTo(".animate-banner", {
				// 	xPercent: -100
				// }, {
				// 	duration: 1,
				// 	ease: "classic",
				// 	xPercent: 0
				// }, '>')
				// .fromTo(".animate-banner > div", {
				// 	xPercent: 100
				// }, {
				// 	duration: 1,
				// 	ease: "classic",
				// 	xPercent: 0
				// }, "<")
				// .fromTo(".animate-banner > div", {
				// 	xPercent: -100
				// }, {
				// 	duration: 2,
				// 	ease: "classic",
				// 	xPercent: 0
				// }, ">-1.4")
				.fromTo(".loading-screen", {
					autoAlpha: 1
				}, {
					duration: 0.3,
					autoAlpha: 0
				}, "<")
				.fromTo(".title-anim-holder", {
					xPercent: -100
				}, {
					duration: 2,
					ease: "classic",
					xPercent: 0
				}, '<')
				.fromTo(".title-anim-holder > div", {
					xPercent: 100
				}, {
					duration: 2,
					ease: "classic",
					xPercent: 0
				}, "<")
				.fromTo(".title__line", {
					xPercent: -100
				}, {
					duration: 1,
					ease: "classic",
					xPercent: 0
				}, '<')
				// Taken out on 18th Sept 2023 upon client request 
				// .fromTo(".animate-video", {
				// 	yPercent: -100
				// }, {
				// 	duration: 1,
				// 	ease: "classic",
				// 	yPercent: 0
				// }, '>+=0.2')
				// .fromTo(".animate-video > div", {
				// 	yPercent: 100
				// }, {
				// 	duration: 1,
				// 	ease: "classic",
				// 	yPercent: 0
				// }, "<")
				// .fromTo(".banner__intro", {
				// 	opacity: 0
				// }, {
				// 	duration: 1,
				// 	ease: "classic",
				// 	opacity: 1
				// }, "<")
				// .fromTo(".top-nav", {
				// 	autoAlpha: 0,
				// 	// y: -30
				// }, {
				// 	duration: 1,
				// 	ease: "classic",
				// 	autoAlpha: 1,
				// 	// y: 0
				// }, "<")
				// .fromTo(".animate-line > div", {
				// 	opacity: 0,
				// 	yPercent: -100
				// }, {
				// 	duration: 1,
				// 	ease: "classic",
				// 	opacity: 1,
				// 	yPercent: 0
				// }, "<")

				.set(document.body, {overflow: "auto"})
			tl.play();
			
		}

		//.fromTo("#rose-bg, #ROSE", {xPercent:-100}, {duration: 2, ease: "power4.out", xPercent:0})
		// .fromTo("#rose-bg-overlay", {xPercent:0}, {duration: 2, ease: "power4.out", xPercent: 100}, "<")
		// .fromTo("#bruford-bg-overlay", {xPercent:0}, {duration: 2, ease: "power4.out", xPercent: 100}, "0.2")
		// .fromTo("#college-bg-overlay", {xPercent:0}, {duration: 2, ease: "power4.out", xPercent: 100}, "0.4")
		// .fromTo("#rose-bg-overlay", {xPercent:100}, {duration: 2, ease: "power4.out", xPercent: 0}, "1")
		// .fromTo("#bruford-bg-overlay", {xPercent:100}, {duration: 2, ease: "power4.out", xPercent: 0}, "1.2")
		// .fromTo("#college-bg-overlay", {xPercent:100}, {duration: 2, ease: "power4.out", xPercent: 0}, "1.4")
		// .fromTo(".loading-screen", {autoAlpha:1}, {duration: 0.3,  autoAlpha:0}, 1)
		// .fromTo(".animate-banner", {xPercent:-100}, {duration: 2, ease: "power4.out", xPercent:0})
		// .fromTo(".animate-banner > div", {xPercent:100}, {duration: 2, ease: "power4.out", xPercent: 0}, "<")
		// .fromTo(".title-anim-holder", {xPercent:-100}, {duration: 2, ease: "power4.out", xPercent:0}, '1')
		// .fromTo(".title-anim-holder > div", {xPercent:100}, {duration: 2, ease: "power4.out", xPercent: 0}, "<")
		// .fromTo(".title__line", {xPercent:-100}, {duration: 1, ease: "power4.out", xPercent:0}, '<')
		// .fromTo(".animate-video", {yPercent:-100}, {duration: 1.5, ease: "power4.out", yPercent:0}, 2)
		// .fromTo(".animate-video > div", {yPercent:100}, {duration: 1.5, ease: "power4.out", yPercent: 0}, "<")
		// .fromTo(".banner__intro", {opacity:0}, {duration: 1, ease: "power4.out", opacity: 1}, "<")
		// .fromTo(".top-nav", { opacity:0}, {duration: 1, ease: "power4.out", opacity: 1}, "<")




	}
	homepageTeaserAnimation: {
		function teaserAnimation() {
			$('.block--teasers-pillar-pages').each(function() {		
	
				var tl = gsap.timeline({
					ease: "power3.inOut",
					scrollTrigger: {
						trigger: $('.block--teasers-pillar-pages'),
						markers: false,
						start: "top center",
						scrub: false,
					}
				});
	
				if($('.animate-teaser').length) {
					tl.from($('.animate-teaser'), {
						duration:  1.3,
						stagger: 0.2,
						x:'100%',
						opacity: 0,

					}, 0.2);
					
					
				
				}
				
				
			});
	
			}
			teaserAnimation();
	}
	homepageEventImageAnimation: {

		function eventImageAnimation() {
		$('.block--events-teaser').each(function() {		

			var tl = gsap.timeline({
				ease: "power3.inOut",
				scrollTrigger: {
					trigger: $('.block--events-teaser'),
					markers: false,
					start: "top center",
					scrub: false,
				}
			});

			if($('.animate-event-img > div').length) {
				tl.fromTo(".animate-event-img > div", {
					xPercent: 100
				}, {
					duration: 2,
					ease: "classic",
					xPercent: 0
				}, "0.5")
				tl.fromTo(".animate-event-img img", {
					xPercent: -100
				}, {
					duration: 2,
					ease: "classic",
					xPercent: 0
				}, "<")
				
				
			
			}
			
			
		});

		}
		eventImageAnimation();
	}

	researchAnimation: {
		function researchAnimation() {
			
			var trigger = $(this);
			// var title = $('.title-anim-holder');
			// var container = $('.block--scrolling-strip__strip');
			const titles = gsap.utils.toArray('.block--scrolling-strip .title-anim-holder');
			const titleInner = gsap.utils.toArray('.block--scrolling-strip .title-anim-holder > h2');
			const lines = gsap.utils.toArray('.block--scrolling-strip__line');

			titles.forEach(title => {
				var tl = gsap.timeline({
					ease: "power3.inOut",
					scrollTrigger: {
						trigger: title,
						markers: false,
						start: "top bottom",
						scrub: false,
					}
				});

				tl.fromTo(title, {
					xPercent: -100
				}, {
					duration: 2,
					ease: "classic",
					xPercent: 0
				}, "0.2")
			});

			titleInner.forEach(title => {
				var tl = gsap.timeline({
					ease: "power3.inOut",
					scrollTrigger: {
						trigger: title,
						markers: false,
						start: "top bottom",
						scrub: false,
					}
				});

				tl.fromTo(title, {
					xPercent: 100
				}, {
					duration: 2,
					ease: "classic",
					xPercent: 0
				}, "0.2")
			});
			lines.forEach(line => {
				var tl = gsap.timeline({
					ease: "power3.inOut",
					scrollTrigger: {
						trigger: line,
						markers: false,
						start: "top bottom",
						scrub: false,
					}
				});

				tl.fromTo(line, {
					width: "0%"
				}, {
					duration: 2,
					ease: "classic",
					width: "71%"
				}, "0.2")
			});
		}
		
		researchAnimation();
	}

	slider: {
		// $(".sf-field-post-meta-course_location").each(function() {
		// 	var radios = $(this).find(":radio").hide();
		// 	$("<div></div>").slider({
		// 	  min: parseInt(radios.first().val(), 10),
		// 	  max: parseInt(radios.last().val(), 10),
		// 	  slide: function(event, ui) {
		// 		radios.filter("[value=" + ui.value + "]").click();
		// 	  }
		// 	}).appendTo(this);
		// });
	}
	scrollingpage: {

		// 	});
		gsap.defaults({
			overwrite: 'auto'
		});
		var xDist;
		if($(window).width() < 1400){
			xDist = -20
		} else {
			xDist = 0;
		}
		gsap.set("#strip-images > *", {
			xPercent: xDist,
			yPercent: -25
		});
		const contentMarkers = gsap.utils.toArray(".scroll-marker");

		const ST = ScrollTrigger.create({
			trigger: "#strip-data",
			// start: "top top",
			// end: "bottom bottom",

			triggerHook: 0,
			start: "top 30%",
			end: "bottom 100%",
		//	markers: true,
			onUpdate: getCurrentSection,
			pin: "#strip-images"
		});



		// Set up our content behaviors
		contentMarkers.forEach(marker => {
			marker.content = document.querySelector(`#${marker.dataset.markerContent}`);

			// gsap.set(marker.content, {
			// 	transformOrigin: "left center"
			// });
			// gsap.set('#' + marker.content.id + ' .block--scrolling-strip__line', {
			// 	transformOrigin: "left"
			// });




			marker.content.enter = function () {

				// gsap.fromTo(marker.content, {
				// 	autoAlpha: 0
				// }, {
				// 	duration: 0.3,
				// 	autoAlpha: 1
				// })
				// gsap.fromTo('#' + marker.content.id + ' .block--scrolling-strip__line', {
				// 	scaleX: 0
				// }, {
				// 	duration: 0.3,
				// 	scaleX: 1,
				// 	delay: 0.3
				// })
				// gsap.fromTo('#' + marker.content.id + ' .title-anim-holder', {
				// 	xPercent: -100
				// }, {
				// 	duration: 0.8,
				// 	ease: "classic",
				// 	xPercent: 0,
				// 	delay: 0.7
				// })
				// gsap.fromTo('#' + marker.content.id + ' .title-anim-holder > h2', {
				// 	xPercent: 100
				// }, {
				// 	duration: 0.8,
				// 	ease: "classic",
				// 	xPercent: 0,
				// 	delay: 0.7
				// })
				// gsap.fromTo('#' + marker.content.id + '', {
				// 	opacity: 0
				// }, {
				// 	duration: 0.8,
				// 	//ease: "power4.out",
				// 	opacity: 1,
				// 	delay: 0.9
				// })
				
				gsap.to(marker.content, {
					duration: 0.8,
					autoAlpha: 1,
					delay: 0
				});
				// gsap.to('#strip-images-1', {
				// 	duration: 0,
				// 	autoAlpha: 0,
				// 	delay: 0.4
				// });

			}

			marker.content.leave = function () {

				// gsap.fromTo('#' + marker.content.id + ' .title-anim-holder', {
				// 	xPercent: 0
				// }, {
				// 	duration: 0.8,
				// 	ease: "classic",
				// 	xPercent: -100,
				// 	delay: 0
				// })
				// gsap.fromTo('#' + marker.content.id + ' .title-anim-holder > h2', {
				// 	xPercent: 0
				// }, {
				// 	duration: 0.8,
				// 	ease: "classic",
				// 	xPercent: 100,
				// 	delay: 0
				// })

				gsap.to(marker.content, {
					duration: 0.1,
					autoAlpha: 0,
					delay: 0.3
				});
			}

		});

		// Handle the updated position
		let lastContent;

		function getCurrentSection() {
			let newContent;
			const currScroll = scrollY;

			// Find the current section
			contentMarkers.forEach(marker => {
				if (currScroll > (marker.offsetTop + marker.offsetHeight + 100)) {
					newContent = marker.content;
				}
			});

			// If the current section is different than that last, animate in
			if (newContent &&
				(lastContent == null ||
					!newContent.isSameNode(lastContent))) {
				// Fade out last section
				if (lastContent) {
					lastContent.leave();
				}

				// Animate in new section
				newContent.enter();

				lastContent = newContent;
			}


		}

		const media = window.matchMedia("screen and (max-width: 768px)");
		ScrollTrigger.addEventListener("refreshInit", checkSTState);
		checkSTState();

		function checkSTState() {
			if (media.matches) {
				ST.disable();
			} else {
				ST.enable();
			}
		}


		// END Scrolling Strip - Animation

	}
	videocursor: {

		if ($('.video-hover').length) {

			// var parent1 = document.querySelector('.video-hover')

			// gsap.set(".video-cursor", {
			// 	xPercent: 50,
			// 	yPercent: 50
			// });
			// var moveTrg = true

			// function move(trg, pos) {
			// 	const rect = document.querySelectorAll('.banner__video, .banner-video-inner');
			// 	const center = {
			// 		w: Math.round(rect.width * 0.5),
			// 		h: Math.round(rect.height * 0.5)
			// 	}
			// 	// Don't go beyond this point if it isn't a new frame


			// 	// Find its child
			// 	var follower = document.querySelector('.video-cursor')

			// 	gsap.to(follower, 0.3, {
			// 		x: pos.x,
			// 		y: pos.y,
			// 		ease: "power4.out"
			// 	})
			// }

			// function onMouseMove(e) {

			// 	// this refers to the caller
			// 	// console.log(this)

			// 	move(this, {
			// 		x: e.clientX,
			// 		y: e.clientY
			// 	})
			// 	console.log('moving');

			// }


			// function onMouseLeave(e) {
			// 	const rect = document.querySelector('.banner__video');
			// 	const center = {
			// 		w: Math.round(rect.width * 0.5),
			// 		h: Math.round(rect.height * 0.5)
			// 	}
			// 	const trg = this.querySelector('.video-cursor')

			// 	gsap.to(trg, 1, {
			// 		x: center.w,
			// 		y: center.h,
			// 		ease: "power4.out"
			// 	})
			// }


			// function initCursor() {

			// 	//	gsap.ticker.addEventListener("tick", function() { moveTrg = true } );

			// 	// Listen for mouse movement when over either one of the parents
			// 	parent1.addEventListener('mousemove', onMouseMove)


			// 	parent1.addEventListener('mouseleave', onMouseLeave)


			// };

			// initCursor();
		}

	}
	parallax: {
		$.fn.moveIt = function () {
			var $window = $(window);
			var instances = [];

			$(this).each(function () {
				instances.push(new moveItItem($(this)));
			});

			window.addEventListener('scroll', function () {
				var scrollTop = $window.scrollTop() / 2;
				instances.forEach(function (inst) {
					inst.update(scrollTop);
				});
			}, {
				passive: true
			});
		}

		var moveItItem = function (el) {
			this.el = $(el);
			this.speed = parseInt(this.el.attr('data-scroll-speed'));
		};

		moveItItem.prototype.update = function (scrollTop) {
			this.el.css('transform', 'translateY(' + -(scrollTop / this.speed) + 'px)');
		};

		// Initialization 
		$(function () {
			$('[data-scroll-speed]').moveIt();
		});
	}
	marquee: {
		var Marquee = function (element, defaults) {
			var elem = document.getElementById(element),
			  options = (defaults === undefined) ? {} : defaults,
			  continuous = options.continuous || true,	// once or continuous
			  direction = options.direction || 'ltr', 	// ltr or rtl
			  loops = options.loops || -1,
			  speed = options.speed || 0.5,
			  milestone = 0,
			  marqueeElem = null,
			  elemWidth = null,
			  self = this,
			  ltrCond = 0,
			  loopCnt = 0,
			  start = 0,
			  textcolor = options.textcolor || '#000000', // Define the text color
			  bgcolor = options.bgcolor || '#ffffff', // Define the background color
			  opacity = options.opacity || 1.0,
			  process = null,
			  constructor = function (elem) {
		  
				// Build html
				var elemHTML = elem.innerHTML;
				var elemNode = elem.childNodes[1] || elem;
				elemWidth = elemNode.offsetWidth;
				marqueeElem = '<div>' + elemHTML + '</div>';
				elem.innerHTML = marqueeElem;
				marqueeElem = elem.getElementsByTagName('div')[0];
				elem.style.overflow = 'hidden';
				marqueeElem.style.whiteSpace = 'nowrap';
				marqueeElem.style.position = 'relative';
				marqueeElem.style.color = textcolor;
				marqueeElem.style.backgroundColor = bgcolor;
				marqueeElem.style.opacity = opacity;
		  
				if (continuous) {
				  marqueeElem.innerHTML += elemHTML;
				  marqueeElem.style.width = '200%';
		  
				  if (direction === 'ltr') {
					start = -elemWidth;
				  }
				} else {
				  ltrCond = elem.offsetWidth;
		  
				  if (direction === 'rtl') {
					milestone = ltrCond;
				  }
				}
		  
				if (direction === 'ltr') {
				  milestone = -elemWidth;
				} else if (direction === 'rtl') {
				  speed = -speed;
				}
		  
				self.start();
		  
				return marqueeElem;
			  }
		  
			this.start = function () {
			  process = window.setInterval(function () {
				self.play();
			  });
			};
		  
			this.play = function () {
			  // beginning
			  marqueeElem.style.left = start + 'px';
			  start = start + speed;
		  
			  if (start > ltrCond || start < -elemWidth) {
				start = milestone;
				loopCnt++;
		  
				if (loops !== -1 && loopCnt >= loops) {
				  marqueeElem.style.left = 0;
				}
			  }
			}
		  
			this.end = function () {
			  window.clearInterval(process);
			}
		  
			// Init plugin
			marqueeElem = constructor(elem);
		  }
		  if ($('#homepage-ticker').length) {
			new Marquee('homepage-ticker', {
				direction: 'rtl',
				bgcolor: 'transparent',
				delayAfter: 0,
				speed: 0.2,
			});
			}		  
	}
});